import { Button, Divider, Row, Typography } from 'antd';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { useBreadcrumbs } from 'src/features/layout/hooks/useBreadcrumbs';

import { ListProgramsTable } from '../components/ListProgramsTable';

const { Title } = Typography;

export const ProgramsV2Screen: FC = () => {
  useBreadcrumbs([
    {
      label: 'Trilhas',
    },
  ]);

  const navigate = useNavigate();

  return (
    <>
      <Row style={{ marginBottom: '40px' }} justify='space-between'>
        <Title level={3}>Programas</Title>

        <Button
          type='primary'
          onClick={() => navigate('/programs/v2/create-or-update')}
        >
          Criar programas
        </Button>
      </Row>

      <Divider style={{ marginBottom: '24px' }} />

      <ListProgramsTable />
    </>
  );
};
